// extracted by mini-css-extract-plugin
export var cookiesBar = "cookies-box-module--cookies-bar--v5JAh";
export var cookiesBarButtonFilled = "cookies-box-module--cookies-bar-button-filled--BiEjI";
export var cookiesBarButtons = "cookies-box-module--cookies-bar-buttons--m9N7i";
export var cookiesBarContent = "cookies-box-module--cookies-bar-content--cPhKx";
export var cookiesModule = "cookies-box-module--cookies-module--KAilS";